export const blockIconsHouseholdDeckNew = (
	<span className='material-symbols-outlined'>deck</span>
);
